import {
  AccountBookOutlined,
  AppstoreOutlined,
  BarChartOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  CloseSquareOutlined,
  DeleteOutlined,
  DownloadOutlined,
  ExportOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  FormOutlined,
  ImportOutlined,
  IssuesCloseOutlined,
  LeftCircleOutlined,
  LockOutlined,
  NotificationOutlined,
  PaperClipOutlined,
  PayCircleOutlined,
  PlusOutlined,
  PoweroffOutlined,
  PrinterOutlined,
  ProfileOutlined,
  RetweetOutlined,
  RightCircleOutlined,
  RollbackOutlined,
  SaveOutlined,
  SearchOutlined,
  StopOutlined,
  TableOutlined,
  UndoOutlined,
  UnlockOutlined,
  UnorderedListOutlined,
  UploadOutlined,
  EditOutlined,
} from '@ant-design/icons';

/** 图表集合 */
export const ICON_COLLECTION = {
  /** 新增 */
  ADD: <PlusOutlined />,
  /** 查看 */
  VIEW: <FileSearchOutlined />,
  /** 编辑 */
  EDIT: <FormOutlined />,
  /** 删除 */
  DELETE: <DeleteOutlined className="text-danger" />,
  /** 带手型的删除 */
  DELETE_ICON: <DeleteOutlined className="text-danger move-pointer" />,
  /** 通过/完成 */
  ADOPT: <CheckCircleOutlined />,
  /** 批量操作 */
  BATCH: <UnorderedListOutlined />,
  /** 绑定 */
  BIND: <PaperClipOutlined />,
  /** 取消 */
  CANCEL: <CloseCircleOutlined />,
  /** 关闭 */
  CLOSE: <CloseOutlined />,
  /** 下载 */
  DOWNLOAD: <DownloadOutlined />,
  /** 草稿箱 */
  DRAFTS: <ProfileOutlined />,
  /** 完结 */
  END: <FileDoneOutlined />,
  /** 审核 */
  EXAMINE: <IssuesCloseOutlined />,
  /** 导入 */
  IMPORT: <ImportOutlined />,
  /** 导出 */
  EXPORT: <ExportOutlined />,
  /** 作废 */
  INVALID: <CloseSquareOutlined />,
  /** 锁定 */
  LOCK: <LockOutlined />,
  /** 解锁 */
  UNLOCK: <UnlockOutlined />,
  /** 下一步 */
  NEXT: <RightCircleOutlined />,
  /** 上一步 */
  PREV: <LeftCircleOutlined />,
  /** 通知 */
  NOTICE: <NotificationOutlined />,
  /** 下单 */
  PLACE_ORDER: <AccountBookOutlined />,
  /** 打印 */
  PRINT: <PrinterOutlined />,
  /** 驳回 */
  REJECT: <RollbackOutlined />,
  /** 重置 */
  RESET: <UndoOutlined />,
  /** 搜索 */
  SEARCH: <SearchOutlined />,
  /** 结算 */
  SETTLEMENT: <PayCircleOutlined />,
  /** 开启 */
  START: <PoweroffOutlined />,
  /** 暂停 */
  STOP: <StopOutlined />,
  /** 提交 */
  SUBMIT: <SaveOutlined />,
  /** 同步 */
  SYNC: <RetweetOutlined />,
  /** 表格 */
  TABLE: <TableOutlined />,
  /** 图表 */
  CHART: <BarChartOutlined />,
  /** 卡片 */
  CARD: <AppstoreOutlined />,
  /** 修改 */
  CHANGE: <EditOutlined />,
  /** 上传 */
  UPLOAD: <UploadOutlined />,
};
